export const NAV_SEARCH_RESULTS_TEST_ID = "nav-search-results";
